import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import ROUTES from '@src/constants/route';
import CrownImg from '@src/assets/images/crown.png';
import { delimitNumber } from '@src/utils/number';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import { MOE_PAYWALL_CTA, MOE_PAYWALL_TYPE } from '@src/constants/moengage';

const FreeMaxCharsLimitExceeded = ({ open, onClose, maxLengthInputText }) => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;
  const history = useHistory();
  const { trackCta } = usePaywallTracking({
    paywallType: MOE_PAYWALL_TYPE.MAX_CHARS,
  });
  const handleUpgradeNow = () => {
    trackCta(MOE_PAYWALL_CTA.UPGRADE);
    history.push(ROUTES.PAYMENT);
  };

  const renderActionButton = () => (
    <>
      <Button className="outlined-button" onClick={onClose}>
        {t('understood')}
      </Button>
      <Button variant="contained" onClick={handleUpgradeNow}>
        {t('upgradePackage')}
      </Button>
    </>
  );
  return (
    <NotificationDialogV4
      image={CrownImg}
      title={t('maxCharsLimitExceeded')}
      description={t('freeMaxCharsLimitExceededDesc', {
        maxLengthInputText: delimitNumber(maxLengthInputText, language),
      })}
      actionComponent={renderActionButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default FreeMaxCharsLimitExceeded;
